import React, { useState, useEffect } from 'react'
import { useSession } from '@slerp/accounts'
import dayjs, { Dayjs } from 'dayjs'
import { Button, Col, message, Row } from 'antd'
import DatePicker from 'components/Common/DayjsDatePicker'

const DATE_FORMAT = 'YYYY-MM-DD'

interface ExportFiltersProps {
  datePickerLabel?: string
  url: string
}

const ExportFilters = ({ datePickerLabel, url }: ExportFiltersProps) => {
  const { user } = useSession()
  const [startDate, setStartDate] = useState<Dayjs | null | undefined>(dayjs())
  const [endDate, setEndDate] = useState<Dayjs | null | undefined>(dayjs())
  const [enableExportStatement, setEnableExportStatement] = useState(true)

  useEffect(() => {
    const isStartEndDatesValid = (startDate || dayjs()) <= (endDate || dayjs())
    setEnableExportStatement(!isStartEndDatesValid)
    if (!isStartEndDatesValid) {
      message.warning('Invalid start and end dates!', 5)
    }
  }, [endDate, startDate])

  const startDateOnChangeHandler = (e: Dayjs | null | undefined) =>
    setStartDate(dayjs(e))
  const endDateOnChangeHandler = (e: Dayjs | null | undefined) =>
    setEndDate(dayjs(e))
  const exportStatementUrl = () => {
    const start = (startDate || dayjs()).format(DATE_FORMAT)
    const end = (endDate || dayjs()).format(DATE_FORMAT)
    return `${url}/export?start=${start}&end=${end}&token=${user?.api_key}`
  }

  return (
    <>
      <Row justify='center' gutter={[16, 16]} align='middle'>
        <Col>{datePickerLabel} Start Date</Col>
        <Col>
          <DatePicker
            defaultValue={startDate ? startDate : undefined}
            format={DATE_FORMAT}
            onChange={startDateOnChangeHandler}
          />
        </Col>
      </Row>
      <Row justify='center' gutter={[16, 24]} align='middle'>
        <Col>{datePickerLabel} End Date</Col>
        <Col>
          <DatePicker
            defaultValue={endDate ? endDate : undefined}
            format={DATE_FORMAT}
            onChange={endDateOnChangeHandler}
          />
        </Col>
      </Row>
      <Row justify='center' gutter={[16, 16]} align='middle'>
        <Col>
          <Button
            disabled={enableExportStatement}
            href={exportStatementUrl()}
            target='_blank'
            rel='noopener noreferrer'
          >
            Export
          </Button>
        </Col>
      </Row>
    </>
  )
}

export default ExportFilters
